// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 2V20H22V22H2V2H4ZM13 6C13 4.34315 14.3431 3 16 3C17.6569 3 19 4.34315 19 6C19 7.65685 17.6569 9 16 9C14.3431 9 13 7.65685 13 6ZM6 14C6 11.7909 7.79086 10 10 10C12.2091 10 14 11.7909 14 14C14 16.2091 12.2091 18 10 18C7.79086 18 6 16.2091 6 14ZM17 14C17 12.8954 17.8954 12 19 12C20.1046 12 21 12.8954 21 14C21 15.1046 20.1046 16 19 16C17.8954 16 17 15.1046 17 14Z"}}]};

const ChartBubbleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-bubble-filled',
    ref,
    icon: element,
  },
));

ChartBubbleFilledIcon.displayName = 'ChartBubbleFilledIcon';

export default ChartBubbleFilledIcon;
